// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"style_mainContainer__je3rM"};